<template>
    <div class="directoryes">

        <div class="directoryes_headline">
      <div class="directoryes_left">
            <h1>Справочник симптомов заболеваний</h1>
      </div>
      <div class="directoryes_right">
        <div class="directoryes_search" style="width: 250px;">
          <label for="search_name">Поиск по названию</label>
          <input
            id="search_name"
            v-model="search"
            class="directoryes_search-input"
          />
          <svg class="svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6679 11.6679C12.0584 11.2774 12.6916 11.2774 13.0821 11.6679L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.6679 13.0821C11.2774 12.6916 11.2774 12.0584 11.6679 11.6679Z" fill="#4854FE"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.125 2C4.29454 2 2 4.29454 2 7.125C2 9.95546 4.29454 12.25 7.125 12.25C9.95546 12.25 12.25 9.95546 12.25 7.125C12.25 4.29454 9.95546 2 7.125 2ZM0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 11.06 11.06 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125Z" fill="#4854FE"/>
          </svg>
        </div>
      </div>
    </div>
        <v-data-table
            class="elevation-1"
            :headers="headers"
            :items="list"
            :loading="loadingTable"
            loading-text="Данные загружаются..."
            :page="page"
            sort-by="code"
            :items-per-page="itemsPerPage"
            :search="search"
            hide-default-footer
        >
            <template v-slot:[`header.name`]="{ header }">
                <span style="font-size: 14px">{{ header.text}}</span>
            </template>
            <template v-slot:[`header.countSymptom`]="{ header }">
                <span style="font-size: 14px">{{ header.text}}</span>
            </template>
            <template v-slot:[`header.code`]="{ header }">
                <span style="font-size: 14px">{{ header.text}}</span>
            </template>
            <template v-slot:[`header.mkb11`]="{ header }">
                <span style="font-size: 14px">{{ header.text}}</span>
            </template>
            <template v-slot:item="{item, index}">
                <tr @mouseover="changeIndex(index)" @mouseleave="indexHover = false" class="gray-bg">
                    <td>{{ item.name }}</td>
                    <td>
                        <div class="d-flex justify-center align-center" style="color: #4854FE;">
                            <button v-if="item.countSymptom > 0" @click="openDialogSymptomsList(item)" style="text-decoration: underline ;" :loading="item.flagOpenSymptom" text small>{{item.countSymptom}}</button>
                            <span v-else>0</span>
                        </div>
                    </td>
                    <td style="text-align: center;" >{{ item.code }}</td>
                    <td style="text-align: center;">{{ item.mkb11 ? item.mkb11 : '-'  }}</td>
                    <td>
                        <div class="d-flex justify-end" v-if="indexHover === index ">
                            <button small @click="editeItems(item)" class="btn">Редактировать</button>
                        </div>
                    </td>
                </tr>
            </template>

            <template v-slot:footer="{ props }">
                <div class="data-footer">
                    <div class="items-per-page">
                        <span>Строк на странице:</span>

                        <div class="items-per-page_item" :class="{active: itemsPerPage == 5}" @click.prevent="itemsPerPage = 5">
                            5
                        </div>
                        <div class="items-per-page_item" :class="{active: itemsPerPage == 10}" @click.prevent="itemsPerPage = 10">
                            10
                        </div>
                        <div class="items-per-page_item" :class="{active: itemsPerPage == 15}" @click.prevent="itemsPerPage = 15">
                            15
                        </div>
                        <div class="items-per-page_item" :class="{active: itemsPerPage == -1}" @click.prevent="itemsPerPage = -1">
                            все
                        </div>
                    </div>
                    <div class="pagination" v-if="itemsPerPage != -1">
                        <div class="pagination_prev" @click.prevent="page == 1 ? page : --page">
                            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z" fill="#94969C"/>
                            </svg>
                        </div>
                        <div class="pagination_number">
                            {{ props.pagination.pageStart + 1 }} - {{ props.pagination.pageStop }} из {{props.pagination.itemsLength}}
                        </div>
                        <div class="pagination_next" v-if="itemsPerPage" @click.prevent="page == props.pagination.pageCount ? page : ++page">
                            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z" fill="#94969C"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </template>

            <v-progress-linear :active="loadingTable" :indeterminate="loadingTable" absolute bottom color="primary accent-4" ></v-progress-linear>
        </v-data-table>

        <!-- Окно кол-ва симптомов -->
        <v-dialog v-model="dialogSymptomsList" max-width="1350px" persistent>
            <div class="d-flex justify-end">
                <v-btn class="close" @click="resetDialogSymptomsList">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                        <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </v-btn>
            </div>
            <v-card max-width="1320px">
                <v-card-title class="justify-space-between">
                    <h3>Симптомы заболевания {{titleSymptom}}</h3>
                    <div class="directoryes_right" style="margin-top:0px">
                        <div class="directoryes_search" style="width: 250px; margin-top:0px">
                        <input
                            id="search_name"
                            style="font-size: 16px; font-weight: normal; "
                            v-model="search1"
                            class="directoryes_search-input"
                        />
                        <svg class="svg" style="top:11px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6679 11.6679C12.0584 11.2774 12.6916 11.2774 13.0821 11.6679L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L11.6679 13.0821C11.2774 12.6916 11.2774 12.0584 11.6679 11.6679Z" fill="#4854FE"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.125 2C4.29454 2 2 4.29454 2 7.125C2 9.95546 4.29454 12.25 7.125 12.25C9.95546 12.25 12.25 9.95546 12.25 7.125C12.25 4.29454 9.95546 2 7.125 2ZM0 7.125C0 3.18997 3.18997 0 7.125 0C11.06 0 14.25 3.18997 14.25 7.125C14.25 11.06 11.06 14.25 7.125 14.25C3.18997 14.25 0 11.06 0 7.125Z" fill="#4854FE"/>
                        </svg>
                        </div>
                    </div>
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-data-table
                                    class="elevation-1"
                                    :headers="headers1"
                                    :items="objScroll.items"
                                    :loading="loadingTable"
                                    loading-text="Данные загружаются..."
                                    :page="page1"
                                    :items-per-page="itemsPerPage1"
                                    :search="search1"
                                    hide-default-footer
                                    >
                                    <template v-slot:[`header.normGroupName`]="{ header }">
                                        <span style="font-size: 14px">{{ header.text}}</span>
                                    </template>
                                    <template v-slot:[`header.name`]="{ header }">
                                        <span style="font-size: 14px">{{ header.text}}</span>
                                    </template>
                                    <template v-slot:[`header.age`]="{ header }">
                                        <span style="font-size: 14px">{{ header.text}}</span>
                                    </template>
                                    <template v-slot:[`header.value`]="{ header }">
                                        <span style="font-size: 14px">{{ header.text}}</span>
                                    </template>
                                    <template v-slot:[`header.frequency`]="{ header }">
                                        <span style="font-size: 14px">{{ header.text}}</span>
                                    </template>
                                    <template v-slot:item="{item}">
                                        <!-- <tr>
                                            <td>{{ item.normGroupName ? item.normGroupName : '-' }}</td>
                                            <td>{{ item.name }}</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                        </tr> -->
                                        <tr v-for="(it, key) in item.ageValues" :key="'B'+item.id+'_'+key"  class="gray-bg">
                                        <td>{{ item.normGroupName ? item.normGroupName : '-' }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>
                                            <span v-if="it.typeAgeOnDay === 1 ">
                                                {{`${it.age.day} дней`}}
                                            </span>
                                            <span v-else-if="it.typeAgeOnDay === 2 && it.age.month">
                                                {{`${it.age.month } мес`}}
                                            </span>
                                            <span v-else-if="it.typeAgeOnDay === 3">
                                                <span v-if="it.age.yearAndMonth.month">{{ `${it.age.yearAndMonth.year} лет ${it.age.yearAndMonth.month} мес` }} </span>
                                                <span v-else>{{ `${it.age.yearAndMonth.year} лет` }}</span>
                                            </span>
                                            <span v-else>
                                                 -
                                            </span>
                                         </td>
                                        <td>
                                            <span v-if="it.valueType === 0">
                                                {{ `${it.valueFrom} - ${it.valueTo} ${it.measurementName} `}}
                                            </span>
                                            <span v-if="it.valueType === 1">
                                                {{ getValue(it.listValueIds, item.listValues).join(', ')}}
                                            </span>
                                        </td>
                                        <td>
                                            <span v-if="it.frequency === 0">
                                                Никогда
                                            </span>
                                            <span v-if="it.frequency === 25">
                                                Редко
                                            </span>
                                            <span v-if="it.frequency === 50">
                                                Часто
                                            </span>
                                            <span v-if="it.frequency === 75">
                                                 Очень часто
                                            </span>
                                            <span v-if="it.frequency === 100">
                                                Всегда
                                            </span>
                                        </td>
                                        </tr>
                                    </template>
                                    <template v-slot:footer="{ props }">
                <div class="data-footer">
                    <div class="items-per-page">
                        <span>Строк на странице:</span>

                        <div class="items-per-page_item" :class="{active: itemsPerPage1 == 5}" @click.prevent="itemsPerPage1 = 5">
                            5
                        </div>
                        <div class="items-per-page_item" :class="{active: itemsPerPage1 == 10}" @click.prevent="itemsPerPage1 = 10">
                            10
                        </div>
                        <div class="items-per-page_item" :class="{active: itemsPerPage1 == 15}" @click.prevent="itemsPerPage1 = 15">
                            15
                        </div>
                        <div class="items-per-page_item" :class="{active: itemsPerPage1 == -1}" @click.prevent="itemsPerPage1 = -1">
                            все
                        </div>
                    </div>
                    <div class="pagination" v-if="itemsPerPage1 != -1">
                        <div class="pagination_prev" @click.prevent="page1 == 1 ? page1 : --page1">
                            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.81409 0.210823C4.94325 0.0744081 5.10763 -4.46523e-07 5.30137 -4.6346e-07C5.68884 -4.97335e-07 6 0.322435 6 0.731679C6 0.936302 5.91781 1.12232 5.78278 1.26494L1.67319 5.5062L5.78278 9.73506C5.91781 9.87768 6 10.0699 6 10.2683C6 10.6776 5.68885 11 5.30137 11C5.10763 11 4.94325 10.9256 4.81409 10.7892L0.246575 6.07666C0.0821913 5.91545 0.00587038 5.71702 -4.80825e-07 5.5C-4.99798e-07 5.28298 0.0821913 5.09696 0.246575 4.92954L4.81409 0.210823Z" fill="#94969C"/>
                            </svg>
                        </div>
                        <div class="pagination_number">
                            {{ props.pagination.pageStart + 1 }} - {{ props.pagination.pageStop }} из {{props.pagination.itemsLength}}
                        </div>
                        <div class="pagination_next" v-if="itemsPerPage1" @click.prevent="page1 == props.pagination.pageCount ? page1 : ++page1">
                            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.18591 0.210823C1.05675 0.0744081 0.892369 -4.46523e-07 0.698631 -4.6346e-07C0.311156 -4.97335e-07 9.33462e-07 0.322435 8.97685e-07 0.731679C8.79796e-07 0.936302 0.0821928 1.12232 0.217222 1.26494L4.32681 5.5062L0.217221 9.73506C0.082192 9.87768 8.13121e-08 10.0699 6.39655e-08 10.2683C2.81882e-08 10.6776 0.311155 11 0.69863 11C0.892368 11 1.05675 10.9256 1.18591 10.7892L5.75343 6.07666C5.91781 5.91545 5.99413 5.71702 6 5.5C6 5.28298 5.91781 5.09696 5.75343 4.92954L1.18591 0.210823Z" fill="#94969C"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </template>

            <v-progress-linear :active="loadingTable" :indeterminate="loadingTable" absolute bottom color="primary accent-4" ></v-progress-linear>
                    </v-data-table>
                                <!-- <v-card v-for="(it, ind) in objScroll.items" :key="'A'+it.id+'_'+ind" class="mb-2">
                                    <v-card-text >
                                        <template>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="6">
                                                    <h4 class="mb-2 title-font">Группа показателя</h4>
                                                    <v-text-field class="title-font" color="#4854FE" outlined disabled dense hide-details v-model="it.normGroupName" label=""/>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="6">
                                                    <h4 class="mb-2 title-font">Наименование</h4>
                                                    <v-text-field class="title-font" color="#4854FE" outlined disabled dense hide-details v-model="it.name" label=""/>
                                                </v-col>

                                                <v-col cols="12" sm="12" md="12">
                                                    <template v-for="(item, key) in it.ageValues">
                                                        <v-row :key="'B'+item.id+'_'+key">
                                                            <v-col cols="2" sm="2" md="2" align-self="start">
                                                                <h4 class="mb-4 title-font">Возраст</h4>
                                                                <v-text-field class="title-font" v-if="item.typeAgeOnDay === 1" color="#4854FE" disabled type="number" outlined dense hide-details v-model="item.age.day" label="Дней" placeholder="От 1 до 29" />

                                                                <v-row v-if="item.typeAgeOnDay === 2">
                                                                    <v-col cols="6" sm="6" md="6">
                                                                        <v-text-field  class="title-font" color="#4854FE" type="number" disabled outlined dense hide-details v-model="item.age.monthAndDay.month" label="Мес." placeholder="1-11" />
                                                                    </v-col>
                                                                    <v-col cols="6" sm="6" md="6">
                                                                        <v-text-field class="title-font" color="#4854FE" type="number" disabled outlined dense hide-details v-model="item.age.monthAndDay.day" label="Дней" placeholder="1-29" />
                                                                    </v-col>
                                                                </v-row>

                                                                <v-row v-if="item.typeAgeOnDay === 3">
                                                                    <v-col cols="6" sm="6" md="6">
                                                                        <v-text-field class="title-font" color="#4854FE" type="number" disabled outlined dense hide-details v-model="item.age.yearAndMonth.year" label="Лет" />
                                                                    </v-col>
                                                                    <v-col cols="6" sm="6" md="6">
                                                                        <v-text-field  class="title-font" color="#4854FE" disabled outlined dense hide-details v-model="item.age.yearAndMonth.month" label="Мес." placeholder="1-11" />
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                            <v-col cols="2" sm="2" md="2" align-self="start" class="mt-5">
                                                                <v-select color="#4854FE" disabled item-text="name" item-value="id" :items="listAgeOnDay" v-model="item.typeAgeOnDay" outlined dense hide-details label="" />
                                                            </v-col>

                                                            <v-col cols="3" sm="3" md="3" align-self="start">
                                                                <h4 class="title-font">Тип</h4>
                                                                <v-radio-group disabled class="mt-0 pt-2" dense hide-details v-model="item.valueType" row>
                                                                    <v-radio color="#4854FE" label="Диапазон" :value="0" />
                                                                    <v-radio color="#4854FE" label="Значение" :value="1" />
                                                                </v-radio-group>
                                                            </v-col>
                                                            <v-col cols="5" sm="5" md="5"  align-self="start">
                                                                <v-row v-if="item.valueType == 0">
                                                                    <v-col cols="2" sm="2" md="2">
                                                                        <h4 class="title-font">От</h4>
                                                                        <v-text-field class="title-font" color="#4854FE" disabled type="number" outlined dense hide-details v-model="item.valueFrom" />
                                                                    </v-col>
                                                                    <v-col cols="3" sm="3" md="2">
                                                                        <h4 class="title-font">До</h4>
                                                                        <v-text-field class="title-font" color="#4854FE" disabled type="number" outlined dense hide-details v-model="item.valueTo" />
                                                                    </v-col>

                                                                    <v-col cols="3" sm="3" md="3">
                                                                        <h4 class="title-font">Ед. изм.</h4>
                                                                        <v-autocomplete title-font color="#4854FE" disabled outlined dense hide-details :items="listMeasurement" item-text="name" item-value="id" v-model="item.measurementId" />
                                                                    </v-col>
                                                                    <v-col cols="4" sm="4" md="5">
                                                                        <h4 class="title-font">Частота проявления</h4>
                                                                        <v-select title-font color="#4854FE" :rules="[rules.required]" disabled :items="listFrequency" item-text="name" item-value="value" outlined dense hide-details v-model="item.frequency" />
                                                                    </v-col>
                                                                </v-row>

                                                                <v-row v-if="item.valueType == 1">
                                                                    <v-col cols="12" sm="12" md="6">
                                                                        <h4 class="title-font">Значение</h4>
                                                                        <v-select color="#4854FE" class="custom-select title-font" :rules="[rules.required]" disabled multiple :items="it.listValues" item-text="name" item-value="id" outlined dense hide-details v-model="item.listValueIds" />
                                                                    </v-col>
                                                                    <v-col :cols="4" sm="4" md="6">
                                                                        <h4 class="title-font">Частота проявления</h4>
                                                                        <v-select class="title-font" color="#4854FE" :rules="[rules.required]" disabled :items="listFrequency" item-text="name" item-value="value" outlined dense hide-details v-model="item.frequency" />
                                                                    </v-col>
                                                                </v-row>
                                                            </v-col>
                                                        </v-row>
                                                    </template>
                                                </v-col>
                                            </v-row>
                                        </template>
                                        <Observer @intersect="intersected(objScroll.items_freeze, objScroll.page, objScroll.size)"/>
                                    </v-card-text>
                                </v-card> -->
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- 1 lvl -->
        <v-dialog v-model="dialog" max-width="1100px" persistent>
            <div class="d-flex justify-end">
            <v-btn class="close" @click="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </v-btn>
        </div>
            <v-card max-width="1050px">
                <v-card-title class="justify-space-between">
                    <h3>{{titleDialog}}</h3>
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-container fluid>
                        <v-row>
                            <!-- мкб-10 -->
                            <v-col cols="12" sm="12" md="12">
                                <h4 class="mb-2 title-font">Наименование заболевания МКБ-10</h4>
                                <v-text-field class="title-font" color="#4854FE" disabled hide-details outlined dense v-model="property.name" label="" />
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <h4 class="mb-2 title-font">Код заболевания МКБ-10</h4>
                                <v-text-field class="title-font" color="#4854FE" disabled hide-details outlined dense v-model="property.code" label="" />
                                <!-- <v-select disabled :items="listMKB10" item-text="code" item-value="code" dense hide-details outlined v-model="property.code" label="Код заболевания МКБ-10" /> -->
                            </v-col>

                            <!-- мкб-11 -->
                            <v-col cols="12" sm="12" md="12">
                                <h4 class="mb-2 title-font">Наименование заболевания МКБ-11</h4>
                                <v-text-field class="title-font" color="#4854FE" disabled hide-details outlined dense v-model="property.mkb11Name" label="" />
                                <!-- <v-select disabled :items="listMKB11" item-text="name" item-value="id" dense hide-details outlined v-model="property.mkb11_Id" label="Наименование заболевания МКБ-11" /> -->
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <h4 class="mb-2 title-font">Код заболевания МКБ-11</h4>
                                <v-text-field class="title-font" color="#4854FE" disabled hide-details outlined dense v-model="property.mkb11" label="" />
                                <!-- <v-select disabled :items="listMKB11" item-text="code" item-value="id" dense hide-details outlined v-model="property.mkb11_Id" label="Код заболевания МКБ-11" /> -->
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                                <h4 class="mb-2 title-font">Примечание</h4>
                                <v-textarea class="title-font" color="#4854FE" rows="3" v-model="property.note" hide-details outlined label="" />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="pb-5 mr-4 d-flex justify-end">
                    <button class="btn mr-2" :loading="saveNoteLoading" @click="saveNote(property)">Сохранить</button>
                    <button class="btn-add" @click="dialogSymptomsOpen(property.id, property.mkb11_Id)">Редактор симптомов</button>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- 2 lvl -->
        <v-dialog v-model="dialogSymptoms" max-width="1150px" persistent>
            <div class="d-flex justify-end">
            <v-btn class="close" @click="closeSymptoms">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </v-btn>
        </div>
            <v-card max-width="1120px">
                <v-card-title class="justify-space-between">
                    <h3>Редактор симптомов заболевания</h3>
                </v-card-title>
                <v-card-text>
                    <v-container fluid>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <div class="mt-3 ml-3 text-subtitle-1 text--primary">
                                    {{ property.name }} ({{ property.code }})
                                </div>
                            </v-col>
                        </v-row>
                        <v-card class="mt-2 mb-2">
                            <v-col>
                                <v-row>
                                    <v-col cols="12" sm="12" md="12">
                                        <h3>Фильтры</h3>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-row>
                                            <v-col cols="12" sm="12" md="5">
                                                <h4 class="title-font">Система организма и методы диагностики</h4>
                                                <v-select class="title-font" color="#4854FE" outlined return-object dense hide-details item-text="name" @change="changeBM(symptomsDialog.lookup, symptomsDialog.methodsId, symptomsDialog.gender, 'system')" item-value="id" :items="listBodySystems" v-model="symptomsDialog.lookup" label="" />
                                            </v-col>
                                            <v-col cols="12" sm="12" md="4">
                                                <h4 class="title-font">Методы физикальных исследований</h4>
                                                <v-select class="title-font" color="#4854FE" clearable outlined dense hide-details item-text="name" @change="changeBM(symptomsDialog.lookup, symptomsDialog.methodsId, symptomsDialog.gender, 'methods')" item-value="id" :items="listMethods" v-model="symptomsDialog.methodsId" label="" />
                                            </v-col>
                                            <v-col  cols="12" sm="12" md="3">
                                                <h4 class="title-font">Пол</h4>
                                                <v-radio-group color="#4854FE" class="mt-2" v-model="symptomsDialog.gender" hide-details dense row @change="changeBM(symptomsDialog.lookup, symptomsDialog.methodsId, symptomsDialog.gender, 'gender')">
                                                    <v-radio color="#4854FE" label="М" :value="0"></v-radio>
                                                    <v-radio color="#4854FE" label="Ж" :value="1"></v-radio>
                                                    <v-radio color="#4854FE" label="МЖ" :value="2"></v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-card>
                        <v-row>
                            <v-col v-if="loading && symptomsDialog.indicatorGroups.length === 0" cols="12" sm="12" md="12">
                                <v-skeleton-loader type="list-item-three-line" />
                            </v-col>
                            <v-col v-if="!loading && symptomsDialog.indicatorGroups.length > 0 " cols="12" sm="12" md="12">
                                <table style="width: 100%" class="elevation-2">
                                    <tbody>
                                        <template v-for="(group, key) in symptomsDialog.indicatorGroups">
                                            <tr v-if="sprHasGroups()" :key="'group_' + group.id + '_' + key" class="border-bottom: 1px gray solid">
                                                <td style="padding: 10px 16px;" class="d-flex align-center">
                                                    <button @click="openIndicatorGroup(key)" small icon class="mr-1">
                                                        <img class="cursor-pointer" v-if="!group.isOpen" svg-inline :src="require('@/assets/img/icons/ArrowRight.svg')" />
                                                        <img class="cursor-pointer" v-if="group.isOpen" svg-inline :src="require('@/assets/img/icons/ArrowDown.svg')" />
                                                    </button>
                                                    <span>{{ group.name }} <a v-if="group.symptomsCount > 0" @click="openIndicatorGroup(key)">({{ group.symptomsCount }})</a></span>
                                                </td>
                                            </tr>
                                            <tr v-if="group.isOpen && sprHasGroups()" :key="'group2_' + group.id + '_' + key">
                                                <td style="padding: 10px 16px;">
                                                    <table style="width: 100%" class="elevation-2">
                                                        <tbody>
                                                            <tr v-for="properties in group.properties" :key="properties.id" class="border-bottom: 1px gray solid">
                                                                <td class="td-is-open px-3">
                                                                    {{ properties.name }} <a v-if="properties.symptomsCount > 0" @click="openProperties(group, properties, true)">({{ properties.symptomsCount }})</a>
                                                                </td>
                                                                <td class="td-is-open" style="text-align: end;">
                                                                    <v-btn @click="openProperties(group, properties, true)" small class="btn-add">+ Добавить симптом</v-btn>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr v-if="!sprHasGroups()" :key="'group2_' + group.id + '_' + key">
                                                <table style="width: 100%" class="elevation-2">
                                                    <tbody>
                                                        <tr class="border-bottom: 1px gray solid">
                                                            <td class="td-is-open px-3">
                                                                {{ group.name }} <a v-if="group.symptomsCount > 0" @click="openProperties(group, group, false)">({{ group.symptomsCount }})</a>
                                                            </td>
                                                            <td class="td-is-open" style="text-align: end;">
                                                                <v-btn @click="openProperties(group, group, false)" small class="btn-add">+ Добавить симптом</v-btn>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </v-col>
                            <v-col v-if="!loading && symptomsDialog.indicatorGroups.length === 0" cols="12" sm="12" md="12">
                                <v-card>
                                    <v-list-item>
                                        <v-list-item-title>
                                            Нет данных
                                        </v-list-item-title>
                                </v-list-item>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- 3 lvl -->
        <v-dialog v-model="dialogProperty" max-width="1200px" persistent>
            <div class="d-flex justify-end">
            <v-btn class="close" @click="closeProperty">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#4854FE" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </v-btn>
        </div>
            <v-card max-width="1150px">
                <v-card-title class="justify-space-between">
                    <h3>Редактирование симптомов</h3>
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-container fluid>
                        <v-form v-model="validProperty" ref="formProperty" lazy-validation>
                            <v-row>
                                <v-col cols="12" sm="12" md="5">
                                    <h4 class="title-font">Наименование</h4>
                                    <v-text-field class="title-font" color="#4854FE" disabled dense hide-details outlined v-model="symptomsDialog.property.name" label="" />
                                </v-col>

                                <v-col cols="12" sm="12" md="3">
                                    <h4 class="title-font">Группа</h4>
                                    <v-text-field class="title-font" color="#4854FE" disabled dense hide-details outlined v-model="symptomsDialog.property.nameGroup" label="" />
                                </v-col>

                                <v-col cols="12" sm="12" md="4">
                                    <h4 class="title-font">Пол</h4>
                                    <v-radio-group color="#4854FE" disabled class="mt-2" v-model="symptomsDialog.property.sex" hide-details dense row>
                                        <v-radio color="#4854FE" label="М" :value="0"></v-radio>
                                        <v-radio color="#4854FE" label="Ж" :value="1"></v-radio>
                                        <v-radio color="#4854FE" label="МЖ" :value="2"></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <v-col cols="12" sm="12" md="12">
                                    <v-card>
                                        <v-card-text>
                                            <v-container>
                                                <h4 class="mb-6 title-font">Возраст</h4>
                                                <div v-for="(item, key) in symptomsDialog.property.ageValues" :key="'A'+item.id+'_'+key">
                                                    <v-row>
                                                        <v-col cols="2" sm="2" md="2" align-self="start">
                                                            <v-text-field class="title-font" color="#4854FE" v-if="item.typeAgeOnDay === 1" disabled type="number" outlined dense hide-details v-model="item.age.day" label="Дней" placeholder="От 1 до 29" />

                                                            <v-row v-if="item.typeAgeOnDay === 2">
                                                                <v-col cols="6" sm="6" md="6">
                                                                    <v-text-field class="title-font" color="#4854FE" type="number" disabled outlined dense hide-details v-model="item.age.monthAndDay.month" label="Мес." placeholder="1-11" />
                                                                </v-col>
                                                                <v-col cols="6" sm="6" md="6">
                                                                    <v-text-field class="title-font" color="#4854FE" type="number" disabled outlined dense hide-details v-model="item.age.monthAndDay.day" label="Дней" placeholder="1-29" />
                                                                </v-col>
                                                            </v-row>

                                                            <v-row v-if="item.typeAgeOnDay === 3">
                                                                <v-col cols="6" sm="6" md="6">
                                                                    <v-text-field class="title-font" color="#4854FE" type="number" disabled outlined dense hide-details v-model="item.age.yearAndMonth.year" label="Лет" />
                                                                </v-col>
                                                                <v-col cols="6" sm="6" md="6">
                                                                    <v-text-field v-if="item.age.yearAndMonth.year < 5 " class="title-font" color="#4854FE" type="number" disabled outlined dense hide-details v-model="item.age.yearAndMonth.month" label="Мес." placeholder="1-11" />
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                        <v-col style=" height: 24px;" cols="2" sm="2" md="2">
                                                            <v-select class="title-font" disabled color="#4854FE" item-text="name" item-value="id" :items="listAgeOnDay" v-model="item.typeAgeOnDay" outlined dense hide-details label="" />
                                                        </v-col>

                                                        <v-col cols="4" sm="4" md="4" align-self="start">
                                                            <v-radio-group color="#4854FE" disabled class="mt-0 pt-2" dense hide-details v-model="item.valueType" row>
                                                                <v-radio color="#4854FE" label="Диапазон" :value="0" />
                                                                <v-radio color="#4854FE" label="Значение" :value="1" />
                                                            </v-radio-group>
                                                        </v-col>

                                                        <!-- Диапазон -->
                                                        <template v-if="item.valueType == 0">
                                                            <v-col cols="1" sm="1" md="1">
                                                                <v-text-field class="title-font" color="#4854FE" :disabled="item.id ? true : false" type="number" :rules="[rules.required, item.valueFrom && item.valueTo ? rules.rangeFromTo(+item.valueFrom, +item.valueTo) : true]" outlined dense hide-details v-model="item.valueFrom" label="От" />
                                                            </v-col>
                                                            <v-col cols="1" sm="1" md="1">
                                                                <v-text-field class="title-font" color="#4854FE" :disabled="item.id ? true : false" type="number" :rules="[rules.required, item.valueFrom && item.valueTo ? rules.rangeFromTo(+item.valueFrom, +item.valueTo) : true]" outlined dense hide-details v-model="item.valueTo" label="До" />
                                                            </v-col>
                                                            <v-col cols="2" sm="2" md="2">
                                                                <v-autocomplete class="title-font" color="#4854FE" :disabled="item.id ? true : false" :rules="[rules.required]" outlined dense hide-details :items="listMeasurement" item-text="name" item-value="id" v-model="item.measurementId" label="Ед. изм." />
                                                            </v-col>
                                                        </template>

                                                        <!-- Значение -->
                                                        <v-col cols="4" sm="4" md="4" v-else-if="item.valueType == 1">
                                                            <!-- {{ symptomsDialog.property }} -->
                                                            <reference-field
                                                                class="title-font"
                                                                color="#4854FE"
                                                                label=""
                                                                v-model="item.listValueIds"
                                                                :items="symptomsDialog.property.listValues"
                                                                :selectedParent="[]"
                                                                :multiple="true"
                                                                :clearable="true"
                                                                :disabled="item.id ? true : false"
                                                                item-text="name"
                                                                item-value="id"
                                                                v-on:saveParams="saveParams($event, symptomsDialog.property)"
                                                                v-on:snackBar="snackBarFunc"
                                                            />
                                                        </v-col>

                                                        <v-col cols="12" sm="12" md="12" class="d-flex justify-end">
                                                            <v-btn @click="addSymptomRow(item)" small class="btn-add">+ Добавить симптом</v-btn>
                                                        </v-col>

                                                    </v-row>

                                                    <v-row v-for="(symptom, keySymptom) in item.symptoms" :key="'symptom_' + item.id + '_' + keySymptom">
                                                        <v-col cols="6" sm="6" md="6"></v-col>

                                                        <v-col cols="6" sm="6" md="6">
                                                            <!-- Диапазон -->
                                                            <v-row v-if="symptom.valueType == 0">
                                                                <v-col cols="3" sm="3" :md="3">
                                                                    <v-text-field class="title-font" color="#4854FE" type="number" :rules="[rules.required, symptom.valueFrom && symptom.valueTo ? rules.rangeFromTo(+symptom.valueFrom, +symptom.valueTo) && !rules.overlapNormRange(item, symptom) : true, rules.negativeNum]" outlined dense hide-details v-model="symptom.valueFrom" label="От" />
                                                                </v-col>
                                                                <v-col cols="3" sm="3" :md="3">
                                                                    <v-text-field class="title-font" color="#4854FE" type="number" :rules="[rules.required, symptom.valueFrom && symptom.valueTo ? rules.rangeFromTo(+symptom.valueFrom, +symptom.valueTo) && !rules.overlapNormRange(item, symptom) : true, rules.negativeNum]" outlined dense hide-details v-model="symptom.valueTo" label="До" />
                                                                </v-col>
                                                                <v-col :cols="4" :sm="4" :md="4">
                                                                    <v-select color="#4854FE" :rules="[rules.required]" :items="listFrequency" item-text="name" item-value="value" outlined dense hide-details v-model="symptom.frequency" label="Частота проявления" />
                                                                </v-col>
                                                                <v-col cols="1" sm="1" :md="1" class="pl-1">
                                                                    <v-tooltip bottom>
                                                                        <template v-slot:activator="{ on, attrs }">
                                                                            <img svg-inline style="width:24px" class="mt-2 cursor-pointer" v-bind="attrs" v-on="on" @click="deleteSymptomRow(item.symptoms, keySymptom)" :src="require('@/assets/img/icons/Trash.svg')" />
                                                                        </template>
                                                                        <span>Удалить симптом</span>
                                                                    </v-tooltip>
                                                                </v-col>
                                                            </v-row>
                                                            <!-- Значение -->
                                                            <v-row v-if="symptom.valueType == 1">
                                                                <v-col :cols="6" :sm="6" :md="6">
                                                                    <!-- {{ symptomsDialog.property }} -->
                                                                    <reference-field
                                                                        class="title-font"
                                                                        color="#4854FE"
                                                                        label=""
                                                                        v-model="symptom.listValueIds"
                                                                        :rules="[rules.requiredMultiple]"
                                                                        :items="symptomsDialog.property.symptom.listValues"
                                                                        :selectedParent="item.listValueIds"
                                                                        :multiple="true"
                                                                        :clearable="true"
                                                                        item-text="name"
                                                                        item-value="id"
                                                                        v-on:saveParams="saveParams($event, symptomsDialog.property.symptom, symptomsDialog.property.listValues)"
                                                                        v-on:snackBar="snackBarFunc"
                                                                    />
                                                                </v-col>
                                                                <v-col :cols="4" :sm="4" :md="4">
                                                                    <v-select color="#4854FE" :rules="[rules.required]" :items="listFrequency" item-text="name" item-value="value" outlined dense hide-details v-model="symptom.frequency" label="Частота проявления" />
                                                                </v-col>
                                                                <v-col cols="1" sm="1" md="1" class="pl-1">
                                                                    <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <img svg-inline style="width:30px" class="mt-2 cursor-pointer" v-bind="attrs" v-on="on" @click="deleteSymptomRow(item.symptoms, keySymptom)" :src="require('@/assets/img/icons/Trash.svg')" />
                                                                    </template>
                                                                    <span>Удалить симптом</span>
                                                                    </v-tooltip>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions class="pb-5 mr-4 d-flex justify-end">
                    <button class="btn mr-2" :loading="saveLoading" @click="saveSymptoms(symptomsDialog, property)">Сохранить</button>
                    <button class="btn-add" @click="closeProperty">Отмена</button>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Импорт -->
        <!-- <v-dialog v-model="dialogImport" max-width="500px" persistent>
            <v-card>
                <v-toolbar dark color="#310539">
                    <v-toolbar-title style="color: #cc74ba">
                        {{ titleDialog }}
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-toolbar-items>
                        <v-btn @click="dialogImport = false" icon color="#cc74ba">
                            <img svg-inline :src="require('@/assets/img/icons/Close.svg')" />
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text class="pb-0">
                    <v-container>
                        <v-form v-model="valid" ref="form" lazy-validation>
                            <v-row>
                                <v-col  cols="12" sm="12" md="12">
                                    <p class="text--primary">Для загрузки новых значений в справочник скачайте шаблон и дополните его нужными Вам значениями</p>
                                    <a @click="downloadFile()" download>Скачать шаблон </a>
                                </v-col>
                                <v-col  cols="12" sm="12" md="12">
                                    <p class="text--primary">После заполнения файла загрузите его в систему</p>
                                </v-col>
                                <v-col  cols="12" sm="12" md="12">
                                    <v-file-input
                                    outlined
                                    dense
                                    label="Загрузить файл"
                                    v-model="guideFile"
                                    accept=".xlsx"
                                    ></v-file-input>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>

                <v-card-actions class="pb-5 d-flex justify-center">
                    <v-btn color="success" :disabled="!guideFile" @click="addFile(guideFile, 'loadFile')">Сохранить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog> -->

        <v-overlay :value="overlay"></v-overlay>

        <v-snackbar rounded="pill" elevation="24" :timeout="timeout" :color="snackbarColor" top v-model="snackbar">
            <div class="d-flex align-center">
                <img svg-inline :src="require('@/assets/img/icons/Information.svg')" />
                <span class="ml-4">{{ snackbar_text }}</span>
            </div>
        </v-snackbar>
    </div>
</template>
<script>
import {mapGetters} from 'vuex'
import referenceField from '@/components/ReferenceField/index.vue'
import { convertingYearsAndMonthsToDays, convertingDaysToYearsAndMonths } from '@/others/transformation'
import Observer from '@/components/VirtualScroll/index.vue'
import "../directory.scss";

export default {
    name: 'SprSymptom',
    components: { referenceField, Observer },
    computed: {
        ...mapGetters({
            apiGuide: 'apiGuide'
        })
    },
    data: () => ({
        objScroll: {
            page: 0,
            items: [],
            items_freeze: [],
            size: 5
        },
        IndicatorsGroupKey: null,
        listAgeOnDay: [
            { id: 1, name: 'Дней' },
            { id: 2, name: 'Месяцев и дней' },
            { id: 3, name: 'Лет и месяцев' }
        ],
        urlSpr: '',
        text:'',
        indexHover: false,
        mkb10_Id: null,
        mkb11_Id: null,
        normDictionaryId: null,
        symptomslistValues: [],
        valid: false,
        groupProperties: {
            id: null
        },
        dialogSymptomsList: false,
        saveNoteLoading: false,
        validProperty: false,
        loading: false,
        saveLoading: false,
        titleSymptom: '',
        dialog: false,
        dialogProperty: false,
        dialogSymptoms: false,
        edite: false,
        overlay: false,
        timeout: 2000,
        snackbar: false,
        snackbar_text: '',
        snackbarColor: '',
        titleDialog: '',
        dialogImport: false,
        guideFile: null,
        loadingTable: false,
        sendingRequest: false,
        listMKB10: [],
        //listMKB11: [],
        listBodySystems: [],
        listMethods: [],
        listMeasurement: [],
        list: [],
        listFrequency: [
            { name: 'Никогда', value: 0 },
            { name: 'Редко', value: 25 },
            { name: 'Часто', value: 50 },
            { name: 'Очень часто', value: 75 },
            { name: 'Всегда', value: 100 }
        ],
        symptomsDialog: {
            globalPropertyId: null,
            edite: false,
            property: {},
            gender: 0,
            lookup: null,
            methodsId: null,
            indicatorGroups: []
        },
        property: {},
        headers: [
            { text: 'Наименование', value: 'name'},
            { text: 'Кол-во симптомов', value: 'countSymptom', align: 'center' },
            { text: 'Код МКБ-10', value: 'code', align: 'center' },
            { text: 'Код МКБ-11', value: 'mkb11', align: 'center'},
            { text: '', value: 'actions', sortable: false, width: 200 }
        ],
        headers1:[
            { text: 'Группа показателей', value: 'normGroupName', sortable: false},
            { text: 'Наименование', value: 'name', sortable: false},
            { text: 'Возраст', value: 'age', sortable: false },
            { text: 'Значение', value: 'value', sortable: false},
            { text: 'Частота проявления', value: 'frequency', sortable: false},
        ],
        pagination: {
            sortBy: 'name'
        },
        page: 1,
        itemsPerPage: 10,
        page1: 1,
        itemsPerPage1: 10,
        search: '',
        search1: '',
        rules: {
            required: (v, text) => (!!v || v === 0) || (text ? text : 'Обязательно для заполнения.'),
            requiredMultiple: (v) => v.length > 0 || 'Обязательно для заполнения.',
            differFromNorm: (indicator, symptom) => {
                return indicator.dictionaryValue != symptom.dictionaryValue
            },
            rangeFromTo: (a, b) => {
                if (a > b) return false;
                if (a < b) return true;
                if (a === b) return true;
                return false
            },
            overlapNormRange: (indicator, symptom) => {
                // console.log(indicator, symptom);
                return (+indicator.valueFrom < +symptom.valueTo && +symptom.valueFrom < +indicator.valueTo) ||
                    (+indicator.valueFrom == +symptom.valueFrom && +indicator.valueTo == +symptom.valueTo)
            }
        }
    }),
    methods:{
        intersected(array, page, size) {
            if(array.length > 0) {
                let start = page * size,
                    end = start + size;

                this.objScroll.page++;
                this.objScroll.items = [...this.objScroll.items, ...array.slice(start, end)];
            }
        },
        changeIndex(index){
        this.indexHover = index
      },
      getValue(value, array){
        let arr = []
        for (let i = 0; i < value.length; i++) {
            for (let j = 0; j < array.length; j++) {
              if(value[i] === array[j].id){
                arr.push(array[j].name)
              }
            }
        }
        return arr;
      },
        editeItems(item){
            this.titleDialog = 'Редактировать заболевание'
            this.edite = true;
            this.property = Object.assign({}, item);
            this.dialog = true
            // this.$http.get(`${this.apiGuide}api/SprSymptom/GetPropertiesByMkbId?mkbId=${item.mkb11_Id}`)
            //     .then((res) => {
            //         console.log(res.data);
            //         this.listMKB11 = res.data;
            //     });

        },
        saveSymptoms(obj, property) {
            if (this.$refs.formProperty.validate()) {
                let ageValues = [];

                for (let i = 0; i < obj.property.ageValues.length; i++) {
                    for (let j = 0; j < obj.property.ageValues[i].symptoms.length; j++) {
                        ageValues.push({
                            id: obj.edite ? obj.property.ageValues[i].symptoms[j].id : undefined,
                            // propertyId: obj.property.ageValues[i].symptoms[j].propertyId,
                            valueType: obj.property.ageValues[i].symptoms[j].valueType,
                            listValueIds: obj.property.ageValues[i].symptoms[j].listValueIds,
                            ageOnDay: obj.property.ageValues[i].symptoms[j].ageOnDay,
                            valueFrom: obj.property.ageValues[i].symptoms[j].valueFrom,
                            valueTo: obj.property.ageValues[i].symptoms[j].valueTo,
                            valueText: obj.property.ageValues[i].symptoms[j].valueText,
                            measurementId: obj.property.ageValues[i].symptoms[j].measurementId,
                            normAgeValueId: obj.property.ageValues[i].symptoms[j].normAgeValueId,
                            frequency: obj.property.ageValues[i].symptoms[j].frequency
                        })
                    }
                }

                if (!obj.edite && ageValues.length === 0) {
                    alert('Добавьте симптомы.');
                    return;
                }

                this.saveLoading = true;
                let url = obj.edite ? 'UpdateProperty' : 'AddProperty';

                this.$http[obj.edite ? 'put' : 'post'](`${this.apiGuide}api/SprSymptom/${url}`, {
                    id: obj.edite ? obj.globalPropertyId : undefined,
                    name: obj.property.name,
                    sex: obj.property.sex,
                    listValues: !obj.edite ? obj.property.symptom.listValues : obj.property.listValues,
                    ageValues: ageValues,
                    mkb10_Id: property.id,
                    mkb11_Id: property.mkb11_Id,
                    normDictionaryId: this.normDictionaryId,
                    normPropertyId: obj.property.id,
                    normKeyName: obj.lookup.keyName,
                    bodySystemId: obj.lookup.keyName === 'SomaticStatus' ? obj.lookup.id : null
                })
                .then((res) => {
                    if (res.status === 200) {
                        this.snackBarFunc(true, 'Сохранение симптомов прошло успешно!!!', 'success');
                        this.saveLoading = false;
                        this.closeProperty()
                    } else {
                        this.snackBarFunc(true, 'Ошибка сохранения симптомов, обратитесь к Администратору!!!', 'error')
                        this.saveLoading = false;
                    }
                })
                .catch((error) => {
                    this.snackBarFunc(true, 'Ошибка сохранения симптомов, обратитесь к Администратору!!!', 'error')
                    this.saveLoading = false;
                })
            } else {
                this.snackBarFunc(true, 'Заполните обязательные поля!!!', 'warning')
            }
        },
        snackBarFunc(flag, text, color) {
			this.snackbar = flag
			this.snackbar_text = text
			this.snackbarColor = color
		},
        close() {
            this.edite = false;
            this.property = {
                name: '',
                groupId: '',
                sex: 2,
                listValues: [],
                ageValues: [
                    {
                        ageOnDay: null,
                        valueType: 0,
                        valueFrom: null,
                        valueTo: null,
                        valueText: '',
                        listValueIds: [],
                        measurementId: null
                    }
                ]
            };
            this.saveLoading = false;
            this.dialog = false;
        },
        openIndicatorGroup(key){
            this.IndicatorsGroupKey = key;
            let group = this.symptomsDialog.indicatorGroups[key];
            group.isOpen = !group.isOpen;

            this.$set(this.symptomsDialog.indicatorGroups, key, group);
        },
        dialogSymptomsOpen(mkb10_Id, mkb11_Id) {
            this.loading = true;
            this.mkb10_Id = mkb10_Id;
            this.mkb11_Id = mkb11_Id;
            this.symptomsDialog.lookup = { id: this.listBodySystems[0].id, keyName: 'SomaticStatus' };
            this.normDictionaryId = '00000000-0000-0000-0000-000000000013';
            this.urlSpr = 'SprSomaticStatus';

            this.$http.get(`${this.apiGuide}api/SprSomaticStatus/FilterGroupsByBodySystem?bodySystemId=${this.symptomsDialog.lookup.id}&sex=${this.symptomsDialog.gender}&mkb10_Id=${this.mkb10_Id}&mkb11_Id=${this.mkb11_Id ?? ''}`)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        this.$set(res.data[i], 'isOpen', false);
                    }
                    this.symptomsDialog.indicatorGroups = this.sortArray(res.data, 'sortOrder');

                    this.symptomsDialog.indicatorGroups.forEach(x => {
                        x.properties = this.sortArray(x.properties, 'sortOrder');
                    });

                    this.loading = false;
                });

            this.dialogSymptoms = true;
        },
        openProperties(group, property, flag) {
            // console.log(group, property, flag);
            this.symptomsDialog.edite = false;
            this.groupProperties.id = property.id;

            if (flag) property.nameGroup = group.name;

            this.symptomsDialog.property = Object.assign({}, convertingDaysToYearsAndMonths(property));

            if (property.symptom !== null) {
                this.symptomsDialog.edite = true;
                this.symptomsDialog.globalPropertyId = property.symptom.id;
            } else {
                this.$http.get(`${this.apiGuide}api/${this.urlSpr}/GetSymptomListValues?propertyId=${property.id}`)
                    .then((res) => {
                        this.symptomsDialog.property.symptom = { listValues: res.data };
                    });
            }

            this.dialogProperty = true;
        },
        addSymptomRow(item) {
            // console.log(item);
            let symptom = Object.assign({}, item);

            symptom.normAgeValueId = item.id
            symptom.id = undefined
            symptom.valueFrom = null
            symptom.valueTo = null
            symptom.listValueIds = []
            symptom.valueText = null
            symptom.frequency = null

            item.symptoms.push(symptom)
            // console.log(this.symptomsDialog.property);
        },
        deleteSymptomRow(array, keySymptom) {
            if (confirm('Вы уверены, что хотите удалить симптом?')) {
                array.splice(keySymptom, 1)
            }
        },
        closeProperty() {
            for (let i = 0; i < this.symptomsDialog.property.ageValues.length; i++) {
                this.symptomsDialog.property.ageValues[i].symptoms = [];
            }
            this.get();
            this.changeBM(this.symptomsDialog.lookup, this.symptomsDialog.methodsId, this.symptomsDialog.gender, 'system');
            this.symptomsDialog.property = {};
            this.dialogProperty = false;
        },
        closeSymptoms() {
            this.dialogSymptoms = false,
            this.symptomsDialog.methodsId = null;
        },
        sortArray(array, name){
            return array.sort((prev, next) => {
                const nameA = typeof prev[name] === 'string' ? prev[name].toUpperCase() : prev[name];
                const nameB = typeof next[name] === 'string' ? next[name].toUpperCase() : next[name];

                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });
        },
        saveNote(property) {
            this.saveNoteLoading = true;

            this.$http.put(`${this.apiGuide}api/SprMkb10/Update`, {
                id: property.id,
                note: property.note
            })
            .then((res) => {
                if(res.status === 200) {
                    for (let i = 0; i < this.list.length; i++) {
                        if(this.list[i].id === res.data.id) {
                            Object.assign(this.list[i], res.data);
                        }
                    }
                    this.dialog = false;
                    this.saveNoteLoading = false;
                }
            })
        },
        changeBM(bodySystemObj, methodsId, gender, name) {
            if (!bodySystemObj) {
                return;
            }

            this.loading = true
            this.urlSpr = '';
            this.normDictionaryId = null;

            if (methodsId && name === 'methods') {
                if (bodySystemObj.keyName !== 'SomaticStatus') {
                    bodySystemObj = { id: this.listBodySystems[0].id, keyName: 'SomaticStatus' };
                    this.symptomsDialog.lookup = bodySystemObj;
                }
            }

            if (bodySystemObj && (name === 'system' || name === 'methods' || name === 'gender')) {
                this.symptomsDialog.indicatorGroups = [];
                this.urlSpr = `Spr${bodySystemObj.keyName}`;

                methodsId = methodsId ? methodsId : '';
                let getUrl = null;

                if (bodySystemObj.keyName === 'SomaticStatus') {
                    this.normDictionaryId = '00000000-0000-0000-0000-000000000013';

                    getUrl = `${this.apiGuide}api/SprSomaticStatus/FilterGroupsByBodySystem?bodySystemId=${bodySystemObj.id}&physResearchId=${methodsId}&sex=${gender}&mkb10_Id=${this.mkb10_Id}&mkb11_Id=${this.mkb11_Id ?? ''}`;
                }
                else {
                    this.normDictionaryId = bodySystemObj.id;
                    this.symptomsDialog.methodsId = null;

                    let actionName = this.sprHasGroups() ? 'FilterGroups' : 'FilterProperties';

                    getUrl = `${this.apiGuide}api/${this.urlSpr}/${actionName}?sex=${gender}&mkb10_Id=${this.mkb10_Id}&mkb11_Id=${this.mkb11_Id ?? ''}`;
                }

                this.$http.get(getUrl)
                    .then((res) => {
                        if (this.sprHasGroups()) {
                            // console.log(res.data);
                            this.setNormGroups(res.data);
                        } else {
                            this.setNormProperties(res.data);
                        }

                        this.loading = false;
                        if (res.data.length === 0) this.text = 'Нет данных'
                    });
            }
        },
        sprHasGroups() {
            return this.urlSpr !== 'SprVitalIndicator' && this.urlSpr !== 'SprAnthropometricIndicator';
        },
        setNormGroups(groups) {
            for (let i = 0; i < groups.length; i++) {
                this.$set(groups[i], 'isOpen', this.IndicatorsGroupKey === i ? true : false);
            }
            this.symptomsDialog.indicatorGroups = this.sortArray(groups.filter((f) => f.properties.length > 0), 'sortOrder');

            this.symptomsDialog.indicatorGroups.forEach(x => {
                x.properties = this.sortArray(x.properties, 'sortOrder');
                x.symptomsCount = 0;

                x.properties.forEach(y => {
                    y.symptomsCount = y.symptom !== null ? y.symptom.ageValues.length : 0;
                    x.symptomsCount += y.symptomsCount;
                });
            });
        },
        setNormProperties(properties) {
            this.symptomsDialog.indicatorGroups = this.sortArray(properties, 'sortOrder');

            this.symptomsDialog.indicatorGroups.forEach(x => {
                x.symptomsCount = x.symptom !== null ? x.symptom.ageValues.length : 0;
            });
        },
        openDialogSymptomsList(item) {
            console.log('openDialogSymptomsList', item);

            item.flagOpenSymptom = true;
            this.titleSymptom = item.name;
            this.search1 = ''
            this.$http.get(`${this.apiGuide}api/SprSymptom/GetPropertiesByMkbId?mkb10_Id=${item.id}&mkb11_Id=${item.mkb11_Id ?? ''}`)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        res.data[i] = Object.assign({}, convertingDaysToYearsAndMonths(res.data[i]));
                    }

                    
                    this.objScroll.items = res.data
                    console.log('this.objScroll.items', this.objScroll.items);
                    // this.objScroll.items_freeze = JSON.parse(JSON.stringify(res.data));
                    // this.intersected(this.objScroll.items_freeze, this.objScroll.page, this.objScroll.size);
                    this.dialogSymptomsList = true;
                    item.flagOpenSymptom = false;
                    // console.log(res.data);
                });
        },
        resetDialogSymptomsList() {
            this.objScroll = {
                page: 0,
                items: [],
                items_freeze: [],
                size: 10
            }
            this.dialogSymptomsList = false;
        },

        S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        },
        guidGener() {
            return (this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4())
        },
        saveParams(event, property, parentValueList) {
            // console.log(event, property, parentValueList);
            let success = true;

            for (let i = 0; i < parentValueList.length; i++) {
                if(parentValueList[i].name === event) {
                    success = false
                    break;
                }
            }

            if(success) {
                if(this.symptomsDialog.edite) {
                    this.$http.post(`${this.apiGuide}api/${this.urlSpr}/AddListValue`, {
                        name: event,
                        propertyId: property.normPropertyId,
                        isPathology: true
                    })
                    .then((res) => {
                        if(res.status === 200) {
                            property.listValues.unshift(res.data);
                        } else {
                            this.snackBarFunc(true, 'Ошибка сохранения значения в справочник, обратитесь к администратору!', 'error');
                        }
                    })
                    .catch((err) => {
                        if(err) {
                            this.snackBarFunc(true, 'Ошибка сохранения значения в справочник, обратитесь к администратору!', 'error');
                        }
                    })
                } else {
                    property.listValues.unshift({id: this.guidGener(), name: event});
                }
            } else {
                this.snackBarFunc(true, 'Ошибка, название значения не должно быть как у нормы!', 'warning');
            }
        },
        get() {
            this.loadingTable = true;

            this.$http.get(`${this.apiGuide}api/SprSymptom/GetPropertiesByMkbSearch`)
            .then((res) => {
                for (let i = 0; i < res.data.length; i++) {
                    this.$set(res.data[i], 'key', `${res.data[i].id}_${res.data[i].mkb11_Id ?? ''}`);
                    this.$set(res.data[i], 'countSymptom', res.data[i].symptoms.length);
                    this.$set(res.data[i], 'flagOpenSymptom', false);
                }
                this.list = res.data;
                this.loadingTable = false;
            });
        }
    },
    created() {
        if(this.$route.query.isDisabled === 'true') {
            this.overlay = true;
            this.snackbar = true;
            this.timeout = -1;
            this.snackbarColor = 'info'
            this.snackbar_text = this.$route.query.placeholder;
        } else {
            this.get();

            this.$http.get(`${this.apiGuide}api/SprBodySystem/GetAll`)
                .then((res1) => {
                    this.listBodySystems = res1.data
                        .map(x => ({
                            id: x.id,
                            name: x.name,
                            keyName: 'SomaticStatus',
                            sortOrder: x.sortOrder
                        }));

                        this.$http.get(`${this.apiGuide}api/SprDictionary/GetForSymptoms`)
                            .then((res2) => {
                                let listDiagnostics = res2.data
                                    .map(x => ({
                                        id: x.id,
                                        name: x.name,
                                        keyName: x.keyName,
                                        sortOrder: x.symptomsSortOrder
                                    }));

                                this.listBodySystems.push(...listDiagnostics);
                                this.listBodySystems = this.sortArray(this.listBodySystems, 'sortOrder');
                            })
                })

            this.$http.get(`${this.apiGuide}api/SprMeasurement/GetAll`)
                .then((res) => {
                    this.listMeasurement = this.sortArray(res.data, 'name');
                })

            this.$http.get(`${this.apiGuide}api/SprPhysResearch/GetAll`)
                .then((res) => {
                    this.listMethods = this.sortArray(res.data, 'sortOrder');
                })
        }
    }
}
</script>

<style scoped lang="scss">
.custom-select .v-select__selection--comma {
    white-space: normal !important;
}
.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
    color: rgba(8, 4, 4, 0.59);
}
.theme--light.v-radio--is-disabled label {
    color: rgba(8, 4, 4, 0.59);
}
.theme--light.v-chip {
    border-color: rgba(8, 4, 4, 7.12);
    color: rgba(8, 4, 4, 8.97);
}
.theme--light.v-select .v-select__selection--disabled {
    color: rgba(8, 4, 4, 0.59);
}
.theme--light.v-label--is-disabled {
    color: rgba(8, 4, 4, 0.59);
}
</style>

<style scoped lang="scss">
.cursor-pointer {
    cursor: pointer;
}
.td-is-open {
    font-size: 0.875rem;
    height: 48px;
}
table {
    border-collapse: collapse;

    tr:not(:last-child) {
        border-bottom: 1px solid lightgray;
    }
}
.btn {
    padding: 6px 12px;
        border-radius: 8px;
        background: #4854FE;
        color: #FFF;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
  }
  .svg {
      position: absolute;
      top: 30px;
      right: 10px;
    }
    .btn-add {
        padding: 6px 12px;
        border-radius: 8px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        white-space: nowrap;
        border: 2px solid #4854FE;
        color: #4854FE !important;
}
.v-btn{
        padding: 6px 12px;
        font-family: Inter;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        white-space: nowrap;
        color: #4854FE !important;
        text-transform: initial;
}
.m{
    margin-left: -10px;
}
.close {
        padding: 0!important;
        min-width: 36px!important;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border-radius: 12px;
        background: #F3F4F6;
        grid-column: 2/2;
        grid-row: 1/1;
}
</style>
